import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

type UseImageSecurityOverviewQuery = {
  clusterIds?: string[];
};

const SECURITY_IMAGE_SECURITY_OVERVIEW_QUERY_KEY =
  'security-image-security-overview';

const getImageSecurityOverviewQueryKey = (clusterIds?: string[]) =>
  [SECURITY_IMAGE_SECURITY_OVERVIEW_QUERY_KEY, clusterIds] as const;

const getImageSecurityOverviewQueryOptions = ({
  clusterIds,
}: UseImageSecurityOverviewQuery) =>
  queryOptions({
    queryKey: getImageSecurityOverviewQueryKey(clusterIds),
    queryFn: async () => {
      const { data } =
        await apiClient.securityInsights.getImageSecurityOverview({
          clusterIds,
        });
      return data;
    },
  });

export const useImageSecurityOverviewQuery = (
  params: UseImageSecurityOverviewQuery = {}
) => {
  const {
    isLoading,
    data: overview,
    error,
    refetch,
  } = useQuery(getImageSecurityOverviewQueryOptions(params));

  return { isLoading, overview, error, refetch };
};
